var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcInfoCircle10X10 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 .833a4.167 4.167 0 1 1 0 8.334A4.167 4.167 0 0 1 5 .833Zm-.52 3.542a.313.313 0 0 0 0 .625h.034a.07.07 0 0 1 .07.07v1.527a.07.07 0 0 1-.07.07H4.48a.313.313 0 0 0 0 .625H5.52a.313.313 0 0 0 0-.625h-.034a.07.07 0 0 1-.07-.07V4.583a.208.208 0 0 0-.208-.208h-.73ZM5 2.708A.52.52 0 1 0 5 3.75a.52.52 0 0 0 0-1.042Z",
  fill: "#BFC6CE"
})));
export default SvgIcInfoCircle10X10;